<template>
  <div>
    <HistoriesTimeline />
  </div>
</template>

<script>
import HistoriesTimeline from '@/components/Application/Sales/Accounts/Account/HistoriesTimeline'
export default {
  components: {
    HistoriesTimeline
  },
  data () {
    return {
      title: 'Histories',
      actions: [],
      breadcrumb: {
        name: 'Histories',
        route: { name: 'sales-accounts-account-histories', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>

<style>

</style>
